var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collection",attrs:{"id":""}},[_c('filters'),_c('div',{staticClass:"a-page"},[_c('productListGrid')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }